import { UpdateApplicationInput } from '../applications/application.interface';
import {
    FteAccountCompletionInput,
    IEducationalInfo,
    IEmergencyContact,
    IStaff,
    IStaffRole,
    IUserTimeOffs,
    StaffAccountCompletion,
    UpdateStaffInput
} from './staff';

export class GetStaff {
    static readonly type = '[Staff] Get Staff';
}

export class GetCasualStaffs {
    static readonly type = '[Staff] casual staff';
    constructor(public input: string) {}
}

export class InviteCasualStaffs {
    static readonly type = '[Staff] invite staff';
    constructor(public input: { ids: string[] }) {}
}
export class GetHiringLeads {
    static readonly type = '[Staff] Get Hiring Leads';
    constructor(public input: string) {}
}

export class GetSingleStaff {
    static readonly type = '[Staff] Get Single Staff';
    constructor(public payload: string) {}
}

export class GetUserWithCode {
    static readonly type = '[staff] get user with code';
    constructor(public payload: string) {}
}

export class GetUserRole {
    static readonly type = '[staff] get user role';
    constructor(public payload: IStaffRole) {}
}

export class GetStaffByFilter {
    static readonly type = '[Staff] Get Staff By Filter';
    constructor(public payload: { department: string; staffType: string; role?: string }) {}
}

export class UpdateStaff {
    static readonly type = '[Staff] Update Staff';
    constructor(public payload: IStaff) {}
}
export class FinanceUpdateStaff {
    static readonly type = '[Staff] Finance Update Staff';
    constructor(public payload: IStaff) {}
}

export class HiringLead {
    static readonly type = '[Staff] hiring lead';
    constructor(public payload: { userId: string }) {}
}

export class AccountCompletion {
    static readonly type = `[Staff] account completion`;
    constructor(public payload: StaffAccountCompletion | null) {}
}

export class CompleteRegistration {
    static readonly type = '[Staff] complete reg';
    constructor(public payload: UpdateStaffInput) {}
}

export class UserDepartment {
    static readonly type = '[Staff] user department';
    constructor(
        public payload: {
            userId: string;
            departmentId: string;
        }
    ) {}
}

export class SubmitRegistration {
    static readonly type = `[Staff] submit reg`;
    constructor(public payload: { id: string }) {}
}
export class UpdateTimeOff {
    static readonly type = '[Staff] hr update user';
    constructor(public input: IUserTimeOffs) {}
}

export class FteAccountCompletion {
    static readonly type = '[Staff] fte account completeion';
    constructor(public payload: FteAccountCompletionInput) {}
}

export class CreateFteEducations {
    static readonly type = '[Staff] fte account completeion education';
    constructor(public payload: IEducationalInfo) {}
}
export class CreateFteEmergencyContact {
    static readonly type = '[Staff] fte account completeion emergency contact';
    constructor(public payload: IEmergencyContact) {}
}
export class UpdateFteEducations {
    static readonly type = '[Staff] fte account completeion education update';
    constructor(public payload: IEducationalInfo) {}
}
export class UpdateFteEmergencyContact {
    static readonly type = '[Staff] fte account completeion emergency contact update';
    constructor(public payload: IEmergencyContact) {}
}

export class DeletdFteEmergencyContactOrEducation {
    static readonly type = '[Staff] delete fte account completeion emergency contact or education';
    constructor(public id: string) {}
}

export class GetSingleFteEmergencyContactOrEducation {
    static readonly type = '[Staff] fte get account completeion emergency contact or education';
    constructor(public payload: { userId: string; title: 'education' | 'emergency' }) {}
}
